import React, { Component } from "react";
import {
  getNearbyPlaces,
  apiGetATFDestination,
  apiGeolocateGoogle,
  apiGetVendorList,
  apiSetVendor,
  getDistanceMatrix,
  apiGetSearchDestination,
  apiCheckPepBoysStore,
} from "utils/API/TrxNowAPI";
import WhiteWrenchIcon from "assets/ui-img/wrenchWhiteCircleBG@2x.png";
import haversineDistance from "haversine-distance";
import { ChevronLeft } from "@mui/icons-material";
import { MagnifyingGlassCircleIcon, MagnifyingGlassIcon } from "@heroicons/react/20/solid";
import { apiRevGeocodeLocationGoogle, apiGetAutocompleteList, apiGetDestinations } from "utils/API/TrxNowAPI";
import { Alert, Divider, Fade } from "@mui/material";
import { Spinner } from "react-bootstrap";
import { PulseLoader } from "react-spinners";
import Button from "react-bootstrap/Button";
import { t } from "i18next";
import { countrySearchWhitelist } from "utils/constants/CountySearchWhitelist";
import Modal from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import { PPUConsentScreen } from "webapp/components/Partner/CIBC/PPUConsentScreen/Index";
import "webapp/components/Partner/CIBC/PPUConsentScreen/PPUConsentScreen.scss";
import { devLog } from "utils/devLog";
import "./SelectDestination.scss";

/**
 *
 * @param {
 * starting coords - import the disablement coords from
 *  the state to generate the local places
 * onUserNext - imports the callback function which will update the main state
 *  with a new destination as necessary
 * t - translation object which allows the view to use i18n translation
 * } props
 * @returns
 */

function validateAddressResult(result) {
  let address_has_needed_componenets = false;

  let bHasStreetNum = false;
  let bHasRoute = false;
  let bHasCity = false;
  let bHasState = false;
  let bHasCountry = false;
  let bHasZip = false;

  for (let j = 0, jLen = result.address_components.length; j < jLen; j++) {
    const comp = result.address_components[j];
    if (!comp || !Array.isArray(comp?.types)) {
      continue;
    }

    if (comp.types.indexOf("route") >= 0) {
      bHasRoute = true;
    } else if (comp.types.indexOf("intersection") >= 0) {
      bHasRoute = true;
    } else if (comp.types.indexOf("street_number") >= 0) {
      bHasStreetNum = true;
    } else if (comp.types.indexOf("locality") >= 0) {
      bHasCity = true;
    } else if (comp.types.indexOf("neighborhood") >= 0) {
      bHasCity = true;
    } else if (comp.types.indexOf("administrative_area_level_3") >= 0) {
      bHasCity = true;
    } else if (comp.types.indexOf("administrative_area_level_1") >= 0) {
      bHasState = true;
    } else if (comp.types.indexOf("country") >= 0) {
      bHasCountry = true;
    } else if (comp.types.indexOf("postal_code") >= 0) {
      bHasZip = true;
    }
  }
  return bHasRoute && bHasCity && bHasState && bHasCountry && bHasZip && bHasStreetNum;
}

function getFixedDistanceLimit(productServiceTypeLimits) {
  if (!productServiceTypeLimits) {
    return 0;
  }
  const len = productServiceTypeLimits?.length || 0;
  for (let l = 0; l < len; l++) {
    const limit = productServiceTypeLimits[l];
    if (limit.serviceType === "Tow") {
      devLog("Tow limit.fixedDistanceLimit: ", limit.fixedDistanceLimit);
      return limit.fixedDistanceLimit;
    }
  }
  return 0;
}

async function getPepBoysSearchDestination(searchTerm, providerRef, companyParams) {
  const data = await apiGetSearchDestination({
    data: {
      providerRef: providerRef,
      searchTerm: searchTerm?.trim() || "",
    },
    companyParams: companyParams,
  });
  devLog("data: ", data);
  return data;
}

function getFixedPrice(productServiceTypeLimits) {
  if (!productServiceTypeLimits) {
    return 0;
  }
  for (let l = 0, lLen = productServiceTypeLimits.length; l < lLen; l++) {
    const limit = productServiceTypeLimits[l];
    if (limit.serviceType === "Tow") {
      devLog("Tow limit.fixedPrice: ", limit.fixedPrice);
      return limit.fixedPrice;
    }
  }
  return 0;
}

function getFixedDistanceFee(productServiceTypeLimits) {
  if (!productServiceTypeLimits) {
    return 0;
  }
  for (let l = 0, lLen = productServiceTypeLimits.length; l < lLen; l++) {
    const limit = productServiceTypeLimits[l];
    if (limit.serviceType === "Tow") {
      devLog("Tow limit.fixedDistanceFee: ", limit.fixedDistanceFee);
      return limit.fixedDistanceFee;
    }
  }
  return 0;
}

/**
 * PBFL only: use campaign tow rates when campaignDetails[0].campaignIsActive; otherwise productServiceTypeLimits (Tow).
 */
function getPBFLTowRateInputs(productServiceTypeLimits, campaignDetails) {
  const regular = {
    fixedDistanceLimit: getFixedDistanceLimit(productServiceTypeLimits),
    fixedPrice: getFixedPrice(productServiceTypeLimits),
    fixedDistanceFee: getFixedDistanceFee(productServiceTypeLimits),
  };
  const campaignDetail = campaignDetails?.[0];
  if (campaignDetail?.campaignIsActive === true) {
    return {
      fixedPrice: Number(campaignDetail.fixedPrice ?? regular.fixedPrice),
      fixedDistanceLimit: Number(campaignDetail.fixedDistanceLimit ?? regular.fixedDistanceLimit),
      fixedDistanceFee: Number(campaignDetail.fixedDistanceFee ?? regular.fixedDistanceFee),
    };
  }
  return regular;
}

function calTowPriceWithDist(distance, fixedDistanceLimit, fixedPrice, fixedDistanceFee) {
  devLog("calTowPriceWithDist distance: ", distance);
  devLog("calTowPriceWithDist fixedDistanceLimit: ", fixedDistanceLimit);
  devLog("calTowPriceWithDist fixedPrice: ", fixedPrice);
  devLog("calTowPriceWithDist fixedDistanceFee: ", fixedDistanceFee);
  if (distance <= fixedDistanceLimit) {
    return fixedPrice;
  } else {
    const extraDistance = distance - fixedDistanceLimit;
    return (fixedPrice + fixedDistanceFee * extraDistance).toFixed(2);
  }
}

export default class SelectDestination extends Component {
  distanceUnit = "mi";
  constructor(props) {
    devLog("SelectDestination props: ", props);
    super(props);
    const isPBFL = props.company === "PBFL";
    const pbflTowRates = isPBFL
      ? getPBFLTowRateInputs(props.currState?.productServiceTypeLimits, props.currState?.campaignDetails)
      : null;

    this.state = {
      disablementCoords: props.startingCoords,
      companyParams: props.companyParams,
      destList: null,
      preferredList: null,
      partner: props.company,
      providerRef: props.providerRef,
      t: props.t,
      searchAddress: null,
      autocompleteList: [],
      isPepBoysStore: false,
      serviceCenters: [],
      showSpinner: false,
      cacheDestination: undefined,
      preferredNRFEnabled: true,
      showSearch: true,
      showSelectBtn: true,
      incompleteAddressMsg: false,
      fixedDistanceLimit: isPBFL ? pbflTowRates.fixedDistanceLimit : null,
      fixedPrice: isPBFL ? pbflTowRates.fixedPrice : null,
      fixedDistanceFee: isPBFL ? pbflTowRates.fixedDistanceFee : null,
      // atfSearch: true,
      pepBoysSearchTimer: null,
      isPepBoysStoreMsgModalOpen: false,
      pepBoysStoreAddress: null,
      pepBoysSearchLoading: false,
      searchLoading: false,
      /** Pep Boys store check + address geocode / distance until navigation */
      destinationSelectLoading: false,
      subPartnerName: props.currState?.appConfig?.subPartnerName,
    };
  }

  //upon render of the component get the nearby places and generate the configReverseGeoCode
  componentDidMount() {
    this.setState({
      showSpinner: true,
    });
    //if partner is confirmed atf, use the atf partner api call to get their specific garage array selection
    // if (this.state?.partner === "ATF") {
    //   devLog("apiGetATFDestination", "BEGIN");
    //   apiGetATFDestination(
    //     this.state.companyParams,
    //     this.state.providerRef,
    //     this.state.partner,
    //     this.state.disablementCoords,
    //     (results) => {
    //       devLog("apiGetATFDestination", results);
    //       this.setState({
    //         destList: [
    //           {
    //             business_status: "OPERATIONAL",
    //             distance: haversineDistance(this.state.disablementCoords, {
    //               lat: results.DestLatitude,
    //               lng: results.DestLongitutde,
    //             }),
    //             geometry: {
    //               location: {
    //                 lat: results.DestLatitude,
    //                 lng: results.DestLongitude,
    //               },

    //               viewport: {
    //                 northeast: {
    //                   lat: results.DestLatitude,
    //                   lng: results.DestLongitude,
    //                 },
    //                 southwest: {
    //                   lat: results.DestLatitude,
    //                   lng: results.DestLongitude,
    //                 },
    //               },
    //             },
    //             icon: null,
    //             icon_background_color: null,
    //             icon_mask_base_uri: null,
    //             name: results.name,
    //             place_id: results.DestCompanyID,
    //             reference: results.DestCompanyID,
    //             types: [
    //               "car_repair",
    //               "point_of_interest",
    //               "store",
    //               "establishment",
    //             ],
    //             user_ratings: 18,
    //             vicinity:
    //               results.DestStreet +
    //               results.DestCity +
    //               results.DestState +
    //               results.DestZip,
    //           },
    //         ],
    //       });
    //     }
    //   );
    // } else
    if (this.state?.partner === "ARIU" || this.state?.partner === "ARIC") {
      this.setState({
        showSearch: !this.state.clientApp ? true : false,
      });

      apiGetVendorList({
        data: {
          providerRef: this.state.providerRef,
          latitude: this.state.disablementCoords.lat,
          longitude: this.state.disablementCoords.lng,
          country: this.props?.currState?.country || this.props?.currState?.DisablementCountry || "US",
          serviceType: "Tow",
        },
        companyParams: this.state.companyParams,
      }).then((data) => {
        // devLog("Holman vendor list: ", data);
        const destList = [];

        for (let i = 0; i < data.vendors.length; i++) {
          const dest = data.vendors[i];
          devLog(`dest[${i}]: `, dest);
          // let distanceKm = haversineDistance(this.state.disablementCoords, {
          //   lat: dest.latitude,
          //   lng: dest.longitude,
          // });
          // devLog(`Holman vendor list ${i} distance: `, distanceKm);
          let distanceKm = (dest.distance * 1.609344).toFixed(2);
          // devLog(`Holman vendor list ${i} distance converted: ${distanceKm}`);

          destList.push({
            business_status: "OPERATIONAL",
            distance: dest.country === "CAN" || dest.country === "Canada" ? distanceKm : dest.distance.toFixed(2),

            geometry: {
              location: {
                lat: dest.latitude,
                lng: dest.longitude,
              },

              viewport: {
                northeast: {
                  lat: dest.latitude,
                  lng: dest.longitude,
                },
                southwest: {
                  lat: dest.latitude,
                  lng: dest.longitude,
                },
              },
            },
            icon: null,
            icon_background_color: null,
            icon_mask_base_uri: null,
            name: dest.name,
            place_id: dest.id,
            reference: dest.id,
            vendorRef: dest.vendorRef,
            types: ["car_repair", "point_of_interest", "store", "establishment"],
            user_ratings: 18,
            vicinity: dest.address + " " + dest.city + " " + dest.state + " " + dest.country + " " + dest.zip,
            distanceUnit: dest.country === "CAN" || dest.country === "Canada" ? "km" : "mi",
          });
          // destList.push({
          //   formattedAddress: dest.formattedAddress,
          //   location: {
          //     latitude: dest.latitude,
          //     longitude: dest.longitude,
          //   },
          //   displayName: {
          //     text: data.text,
          //     languageCode: data.languageCode,
          //   },
          // });
        }
        // devLog("destList: ", destList);
        this.setState({
          showSpinner: false,
          destList: destList,
        });
      });
    }
    //if any other partner is used, the standard get destination list is used.
    else {
      // devLog("Trying to get nearby locations...");

      if (!this.state.disablementCoords) {
        // devLog("no disablement coords -- connected?");
        return;
      }

      /**
       * 1. Put in a spinner that tells the user we are fetching nearby service centers
       * 2. fetch the destination list from salesforce (apiGetDestinations)
       * 3. fetch the list of nearby locations via the Google API
       * 4. hide spinner
       * 5. show list of destinations to the user
       */

      /**
       * if the user searches for an addess in the search box, hide the destination list from Salesforce.
       * If the user clears their search, show the destination list from salesforce again.
       */
      if (
        (this.state.preferredNRFEnabled || this.state?.partner === "ATF") &&
        (this.state.cacheDestination === undefined ||
          this.state.cacheDestination.lat !== this.state.disablementCoords.lat ||
          this.state.cacheDestination.lng !== this.state.disablementCoords.lng)
      ) {
        if (this.state?.partner === "ATF") {
          this.setState({
            showSearch: true,
            showSelectBtn: true,
          });
        }
        apiGetDestinations({
          data: {
            providerRef: this.state.providerRef,
            latitude: this.state.disablementCoords.lat,
            longitude: this.state.disablementCoords.lng,
            country: "US",
            serviceType: "Tow",
          },
          companyParams: this.state.companyParams,
        }).then((/** @type {DestinationResponse} data */ data) => {
          // devLog("DestinationResponse", data);
          if (data && Array.isArray(data.destinations)) {
            const serviceCenters = data.destinations.map((destination) => {
              // devLog("destination:", destination);
              return {
                preferred: true,
                DestCompanyID: destination?.providerRef,
                business_status: "OPERATIONAL",
                distance: destination.distance
                  ? parseFloat(destination.distance).toFixed(2)
                  : parseFloat(
                      haversineDistance(this.state.disablementCoords, {
                        lat: destination.latitude,
                        lng: destination.longitude,
                      }),
                    ).toFixed(2),
                geometry: {
                  location: {
                    lat: destination.latitude,
                    lng: destination.longitude,
                  },

                  viewport: {
                    northeast: {
                      lat: destination.latitude,
                      lng: destination.longitude,
                    },
                    southwest: {
                      lat: destination.latitude,
                      lng: destination.longitude,
                    },
                  },
                },
                icon: null,
                icon_background_color: null,
                icon_mask_base_uri: null,
                name: destination.name,
                place_id: destination.placeId,
                reference: destination.placeId,
                types: ["car_repair", "point_of_interest", "store", "establishment"],
                user_ratings: 18,
                vicinity: destination.address + " " + destination.city,
                distanceUnit: destination?.country === "United States" || destination?.country === "USA" ? "mi" : "km",
                // +
                // " " +
                // destination.state +
                // " " +
                // destination.postalCode,
              };
            });
            // if (this.state?.partner === "PBFL") {
            //   serviceCenters = serviceCenters.filter(
            //     (destination) =>
            //       destination.name.includes("Pep Boys") ||
            //       destination.name.includes("pep boys") ||
            //       destination.name.includes("PEP BOYS"),
            //   );
            // }
            this.setState(
              {
                serviceCenters: serviceCenters,
                cacheDestination: this.state.disablementCoords,
              },
              () => {
                // devLog("ServiceCenter:", serviceCenters);
                // if (this.state?.partner !== "ATF") {
                if (this.state?.partner !== null) {
                  this.searchForNearbyPlaces();
                  // this.setState({
                  //   showSpinner: false,
                  // });
                  //   destList: null,
                  //   preferredList: [...this.state.serviceCenters],
                  // });
                } else {
                  if (serviceCenters.length) {
                    apiRevGeocodeLocationGoogle(
                      {
                        lat: serviceCenters[0].geometry.location.lat,
                        lng: serviceCenters[0].geometry.location.lng,
                      },
                      (result) => {
                        // devLog("result", result);
                        const item = serviceCenters[0];
                        if (typeof item === "object" && item.name) {
                          result.title = item.name;
                        }
                        this.props.onUserNext(result, item);
                      },
                    );
                  } else {
                    this.setState({
                      showSearch: false,
                      showSpinner: false,
                      destList: [...serviceCenters],
                      // preferredList: [...serviceCenters],
                    });
                  }
                }
              },
            );
          }
        });
      } else {
        this.searchForNearbyPlaces();
        devLog("Not ATF");
      }
    }
  }

  componentWillUnmount() {
    // Clean up timers to prevent memory leaks
    if (this.state.searchTimer) {
      clearTimeout(this.state.searchTimer);
    }
    if (this.state.pepBoysSearchTimer) {
      clearTimeout(this.state.pepBoysSearchTimer);
    }
  }

  searchForNearbyPlaces = (searchText) => {
    getNearbyPlaces(this.state.disablementCoords, searchText, (response) => {
      // devLog("getNearbyPlaces searchForNearbyPlaces:", response.places);

      //filter array for companies that we don't want to present to the user
      const invalidNames = ["AJ Graphics", "NAPA Auto Parts", "NAPA Auto Parts"];

      let filteredArray = response.places
        .filter((item) => {
          if (invalidNames.includes(item.displayName.text)) {
            return false;
          } else if (
            this.state?.partner === "PBFL" &&
            (!item.displayName.text.includes("Pep Boys") ||
              !item.displayName.text.includes("pep boys") ||
              !item.displayName.text.includes("PEP BOYS"))
          ) {
            return false;
          } else {
            return true;
          }
        })
        .map((item) => {
          return {
            name: item.displayName.text,
            geometry: {
              location: {
                lat: item.location.latitude,
                lng: item.location.longitude,
              },
              viewport: {
                northeast: {
                  lat: item.location.latitude,
                  lng: item.location.longitude,
                },
                southwest: {
                  lat: item.location.latitude,
                  lng: item.location.longitude,
                },
              },
            },
            icon: "",
            icon_background_color: "white",
            icon_mask_base_uri: "",
            place_id: "",
            reference: "",
            types: [],
            user_ratings: [],
            vicinity: item.formattedAddress,
            distanceUnit: item.formattedAddress.includes("USA") ? this.distanceUnit : "km",
          };
        });
      // devLog("serviceCenters | preferredList: ", this.state.serviceCenters);

      // Wait for all distance matrix API calls to complete
      const currLat = this.state.disablementCoords.lat;
      const currLng = this.state.disablementCoords.lng;

      const destCoords = [];

      // devLog("destCoords: ", destCoords);

      filteredArray.map((place) => {
        const destLat = place.geometry.location.lat;
        const destLng = place.geometry.location.lng;

        destCoords.push({
          lat: destLat,
          lng: destLng,
        });
      });

      devLog("filteredArray: ", filteredArray);

      const distancePromises = new Promise((resolve) => {
        getDistanceMatrix(currLat, currLng, destCoords, (results) => {
          devLog("results: ", results);
          resolve(results);
        });
      });

      distancePromises
        .then((filteredArrayWithDistance) => {
          devLog("filteredArrayWithDistance: ", filteredArrayWithDistance);
          const filteredArrayWithDistance2 = filteredArray.map((place, index) => {
            const currPlace = { ...place };
            const distanceData = filteredArrayWithDistance.find((item) => item.destinationIndex === index);

            if (distanceData) {
              if (place.vicinity.includes("Canada") || place.vicinity.includes("CAN")) {
                currPlace.distance = (distanceData.distanceMeters / 1000).toFixed(2);
                currPlace.distanceUnit = "km";
              } else {
                currPlace.distance = (distanceData.distanceMeters * 0.000621371).toFixed(2);
                currPlace.distanceUnit = "mi";
              }
            }
            return currPlace;
          });

          devLog("filteredArrayWithDistance2: ", filteredArrayWithDistance2);
          this.setState({
            showSpinner: false,
            destList: [...filteredArrayWithDistance2],
            preferredList: [...this.state.serviceCenters],
          });
        })
        .catch((error) => {
          console.error("Error getting distance matrix:", error);
          this.setState({
            showSpinner: false,
            destList: [...filteredArray],
            preferredList: [...this.state.serviceCenters],
          });
        });
    });
  };

  handleSelection = (data, item) => {
    devLog("handleSelection called");
    devLog("handleSelection data: ", data);
    devLog("handleSelection item: ", item);
    if (!data || !data.lat || !data.lng) {
      devLog("Invalid data selected");
      this.setState({ destinationSelectLoading: false });
      return;
    }

    try {
      if (
        this.state?.partner === "ARIU" ||
        this.state?.partner === "ATF" ||
        this.state?.partner === "ARIC" ||
        !!item.vendorRef
      ) {
        apiSetVendor({
          data: {
            providerRef: this.state.providerRef,
            vendorRef: item.vendorRef,
          },
          companyParams: this.state.companyParams,
        }).then((data) => {
          devLog(data);
        });
      }
    } catch (e) {
      this.setState({ destinationSelectLoading: false });
      console.error(e);
    }

    let towPrice;
    if (this.state?.partner === "PBFL") {
      towPrice = calTowPriceWithDist(
        this.state.subPartnerName === "Sears Transformco"
          ? Math.ceil(item.distance)
          : parseFloat(item.distance).toFixed(2),
        this.state.fixedDistanceLimit,
        this.state.fixedPrice,
        this.state.fixedDistanceFee,
      );
    }

    apiRevGeocodeLocationGoogle({ lat: data.lat, lng: data.lng }, (result) => {
      devLog("result", result);
      if (typeof item === "object" && item.name) {
        result.title = item.name;
      }
      this.setState({ destinationSelectLoading: false });
      this.props.onUserNext(result, item, towPrice !== undefined ? { towPrice } : undefined);
    });

    devLog("handleSelection completed");
    //ReverseGeoCode({lat: data.lat, lng: data.lng}, (data)=>{this.props.onUserNext(data)})
  };

  checkAddress = (results) => {
    let bAddressValidate = false;
    let addressList = results;
    let validateAddrListPosition = -1;
    for (let addr = 0; addr < addressList.length; addr++) {
      let bHasStreetNum = false;
      let bHasStreet = false;
      let bHasCity = false;
      let bHasCounty = false;
      let bHasState = false;
      let bHasCountry = false;
      let bHasZip = false;
      const addrComponentLen = addressList[addr].address_components.length;
      for (let com = 0; com < addrComponentLen; com++) {
        let component = addressList[addr].address_components[com];
        for (let type = 0; type < 1; type++) {
          if (component.types.indexOf("street_number") >= 0) {
            bHasStreetNum = true;
          } else if (component.types.indexOf("route") >= 0) {
            bHasStreet = true;
          } else if (component.types.indexOf("plus_code") >= 0) {
            bHasStreet = true;
          } else if (component.types.indexOf("locality") >= 0) {
            bHasCity = true;
          } else if (component.types.indexOf("neighborhood") >= 0) {
            bHasCity = true;
          } else if (component.types.indexOf("administrative_area_level_2") >= 0) {
            bHasCounty = true;
          } else if (component.types.indexOf("administrative_area_level_1") >= 0) {
            bHasState = true;
          } else if (component.types.indexOf("country") >= 0) {
            bHasCountry = true;
          } else if (component.types.indexOf("postal_code") >= 0) {
            bHasZip = true;
          }
        }
        if (bHasStreetNum && bHasStreet && bHasCity && bHasState && bHasCountry && bHasZip) {
          validateAddrListPosition = addr;
          return validateAddrListPosition;
        }
      }
    }
    devLog("validateAddrListPosition: " + validateAddrListPosition);
    return validateAddrListPosition;

    // const addrListLength = address.address_components.length;
    // for (let com = 0; com < addrListLength; com++) {
    //   let component = address.address_components[com];
    //   for (let type = 0; type < 1; type++) {
    //     if (component.types.indexOf("street_number") >= 0) {
    //       bHasStreetNum = true;
    //     } else if (component.types.indexOf("route") >= 0) {
    //       bHasStreet = true;
    //     } else if (component.types.indexOf("plus_code") >= 0) {
    //       bHasStreet = true;
    //     } else if (component.types.indexOf("locality") >= 0) {
    //       bHasCity = true;
    //     } else if (
    //       component.types.indexOf("administrative_area_level_2") >= 0
    //     ) {
    //       bHasCounty = true;
    //     } else if (
    //       component.types.indexOf("administrative_area_level_1") >= 0
    //     ) {
    //       bHasState = true;
    //     } else if (component.types.indexOf("country") >= 0) {
    //       bHasCountry = true;
    //     } else if (component.types.indexOf("postal_code") >= 0) {
    //       bHasZip = true;
    //     }
    //   }
    // }
  };

  handleSearch = (searchText) => {
    devLog("searchText:", searchText);
    // clear previous timer if called again quickly
    // this.setState({ atfSearch: false });
    clearTimeout(this.state.searchTimer);
    // start a timer to call api shortly after user stops typing
    const newTimer = setTimeout(() => {
      // call api
      if (!searchText && searchText.length < 1) {
        // this.setState({ autocompleteList: [], atfSearch: false });
        this.setState({ autocompleteList: [] });
      } else {
        // this.setState({ atfSearch: true });
        // this.searchForNearbyPlaces(searchText);
        this.getAutoCompleteList(searchText);
      }
    }, 500);
  };

  openPEPMsgModal = (address) => {
    devLog("openPEPMsgModal: ", address);
    devLog("openPEPMsgModal this.state: ", this.state);
    this.setState(
      {
        isPepBoysStoreMsgModalOpen: true,
        pepBoysStoreAddress: address,
        isPepBoysStore: false, // Set to false for non-PepBoys store selection
      },
      () => {
        devLog("openPEPMsgModal this.state after setState: ", this.state);
      },
    );
  };

  checkPepBoysStore = (formattedAddress) => {
    devLog("checkPepBoysStore: ", formattedAddress);
    this.setState({ destinationSelectLoading: true });
    const streetName = formattedAddress.split(",")[0].trim();
    const city = formattedAddress.split(",")[1].trim();
    const stateWithZip = formattedAddress.split(",")[2].trim();
    const state = stateWithZip.split(" ")[0].trim();
    const postalCode = stateWithZip.split(" ")[1].trim();

    apiCheckPepBoysStore({
      data: {
        street: streetName,
        city: city,
        stateCode: state,
        postalCode: postalCode,
      },
      companyParams: this.state.companyParams,
    })
      .then((res) => {
        const data = res?.data != null ? res.data : res;
        if (!data?.destinationFound || !data?.destination) {
          this.setState({ destinationSelectLoading: false }, () => {
            this.openPEPMsgModal(formattedAddress);
          });
          return;
        }
        const dest = data.destination;
        const coords = {
          lat: dest.latitude,
          lng: dest.longitude,
        };
        const towDistanceUnit = "mi";

        const destCompanyId = dest.id;

        const nrfItem = {
          name: dest.name ?? dest.storeName ?? "Pep Boys",
          DestCompanyID: destCompanyId,
        };

        const distancePromise = new Promise((resolve, reject) => {
          getDistanceMatrix(
            this.state.disablementCoords.lat,
            this.state.disablementCoords.lng,
            [coords],
            (matrixRows) => {
              if (matrixRows && matrixRows[0] && matrixRows[0].distanceMeters != null) {
                resolve(matrixRows);
              } else {
                reject(new Error("No distance matrix result for Pep Boys store"));
              }
            },
          );
        });

        distancePromise
          .then((matrixRows) => {
            const meters = matrixRows[0].distanceMeters;
            const distanceStr =
              towDistanceUnit === "km" ? (meters / 1000).toFixed(2) : (meters * 0.000621371).toFixed(2);
            nrfItem.distance = distanceStr;
            nrfItem.distanceUnit = towDistanceUnit;
            this.handleSelection(coords, nrfItem);
          })
          .catch((error) => {
            console.error("Error getting distance matrix for Pep Boys store:", error);
            this.setState({ destinationSelectLoading: false });
          });
      })
      .catch((error) => {
        console.error("Error checking Pep Boys store:", error);
        this.setState({ destinationSelectLoading: false });
      });
  };

  closePEPMsgModal = () => {
    this.setState(
      {
        isPepBoysStoreMsgModalOpen: false,
        pepBoysStoreAddress: null,
      },
      () => {
        devLog("closePEPMsgModal this.state after setState: ", this.state);
      },
    );
  };

  handleAddressSelection = (address) => {
    devLog("handleAddressSelection: ", address);
    this.setState({ destinationSelectLoading: true });
    const currLat = this.state.disablementCoords.lat;
    const currLng = this.state.disablementCoords.lng;
    devLog("this.state handleAddressSelection: ", this.state);
    const towDistanceUnit =
      this.state.partner === "PBFL"
        ? "mi"
        : this.state.destList[0].vicinity.includes("CAN") || this.state.destList[0].vicinity.includes("Canada")
          ? // this.state.destList[0].vicinity.includes("CA")
            "km"
          : "mi";

    devLog("towDistanceUnit: ", towDistanceUnit);

    // this is a bit of a hack to make sure the data
    // ends up in googles format - ok it's an ugly hack...
    devLog("Geolocate with google");
    apiGeolocateGoogle(address, (response) => {
      try {
        devLog("Geolocate with google worked:", response.results);
        let position = this.checkAddress(response?.results);
        if (response.results.length > 0 && position >= 0) {
          const destCoords = [
            {
              lat: response.results[0].geometry.location.lat,
              lng: response.results[0].geometry.location.lng,
            },
          ];

          devLog("destCoords: ", destCoords);
          let distance = 0;

          const distancePromise = new Promise((resolve) => {
            getDistanceMatrix(currLat, currLng, destCoords, (res) => {
              resolve(res);
            });
          });

          distancePromise
            .then((distanceResult) => {
              devLog("distanceResult: ", distanceResult);
              distance = distanceResult[0].distanceMeters;
              distance = towDistanceUnit === "km" ? (distance / 1000).toFixed(2) : (distance * 0.000621371).toFixed(2);

              this.setState({
                incompleteAddressMsg: false,
              });

              const coords = response.results[position].geometry.location;
              const distanceData = {
                distance: distance,
                distanceUnit: towDistanceUnit,
              };

              if (coords && distanceData) {
                devLog("Sending coords");
                this.handleSelection(coords, distanceData);
              } else {
                devLog("Invalid coords received for handleSelection");
                this.setState({ destinationSelectLoading: false });
              }
            })
            .catch((error) => {
              console.error("Error getting distance matrix:", error);
              this.setState({ destinationSelectLoading: false });
            });
        } else {
          this.setState({
            incompleteAddressMsg: true,
            destinationSelectLoading: false,
          });
          devLog("No results from Geolocation");
        }
      } catch (e) {
        console.error("handleAddressSelection geocode callback:", e);
        this.setState({ destinationSelectLoading: false });
      }
    });
  };

  handleSearch = (searchText) => {
    devLog("searchText:", searchText);
    // clear previous timer if called again quickly
    // this.setState({ atfSearch: false });
    clearTimeout(this.state.searchTimer);
    // Clear loading state if search text is empty
    if (!searchText || searchText.length === 0) {
      this.setState({
        searchLoading: false,
        autocompleteList: [],
      });
    }
    // start a timer to call api shortly after user stops typing
    const newTimer = setTimeout(() => {
      // call api
      if (!searchText && searchText.length < 1) {
        // this.setState({ autocompleteList: [], atfSearch: false });
        this.setState({
          autocompleteList: [],
          searchLoading: false,
        });
      } else {
        // this.setState({ atfSearch: true });
        // this.searchForNearbyPlaces(searchText);
        this.setState({ searchLoading: true });
        this.getAutoCompleteList(searchText);
      }
    }, 500);

    this.setState({
      searchTimer: newTimer,
      searchAddress: searchText,
    });
  };

  handlePepBoysSearch = (searchText) => {
    devLog("handlePepBoysSearch searchText:", searchText);
    // clear previous timer if called again quickly
    if (this.state.pepBoysSearchTimer) {
      clearTimeout(this.state.pepBoysSearchTimer);
    }
    // Clear loading state if search text is empty
    if (!searchText || searchText.length === 0) {
      this.setState({
        pepBoysSearchLoading: false,
        autocompleteList: [],
        isPepBoysStore: false,
      });
    }
    // start a timer to call api 800ms after user stops typing
    const newTimer = setTimeout(async () => {
      // call api
      if (searchText && searchText.length > 0) {
        // Reset flag when starting new search and show spinner
        this.setState({
          isPepBoysStore: false,
          pepBoysSearchLoading: true,
        });
        try {
          const results = await getPepBoysSearchDestination(
            searchText,
            this.state.providerRef,
            this.state.companyParams,
          );
          devLog("getPepBoysSearchDestination response data: ", results.data.destinations);

          // Handle different possible response structures
          const destinations = results.data?.destinations;
          if (destinations && Array.isArray(destinations) && destinations.length > 0) {
            devLog("Setting autocompleteList with destinations: ", destinations);
            this.setState(
              {
                autocompleteList: destinations,
                isPepBoysStore: true,
                pepBoysSearchLoading: false,
              },
              () => {
                devLog("handlePepBoysSearch this.state after setState: ", this.state);
              },
            );
          } else {
            // No PepBoys stores found, use regular search
            this.setState({
              isPepBoysStore: false,
              pepBoysSearchLoading: false,
              searchLoading: true, // Start loading for regular search
            });
            this.handleSearch(searchText);
            devLog("No destinations found in response, call regular search");
            return;
          }

          // if (destinations && destinations.length > 0) {
          //   devLog("Setting autocompleteList with destinations: ", destinations);
          //   this.setState({
          //     autocompleteList: destinations,
          //   });
          // } else {
          //   devLog("No destinations found in response, clearing autocompleteList");
          //   this.setState({
          //     autocompleteList: [],
          //   });
          // }
        } catch (error) {
          console.error("Error in getPepBoysSearchDestination:", error);
          this.setState({
            autocompleteList: [],
            isPepBoysStore: false,
            pepBoysSearchLoading: false,
          });
        }
      } else {
        // Clear autocomplete list if search text is empty
        this.setState({
          autocompleteList: [],
          isPepBoysStore: false,
          pepBoysSearchLoading: false,
        });
      }
    }, 300);

    this.setState({
      pepBoysSearchTimer: newTimer,
    });
  };

  getAutoCompleteList = (address) => {
    const cusLat = this.state.disablementCoords.lat;
    const cusLng = this.state.disablementCoords.lng;

    // const northStrict = cusLat + 0.1;
    // const southStrict = cusLat - 0.1;
    // const eastStrict = cusLng + 0.1;
    // const westStrict = cusLng - 0.1;

    if (address && address.length > 3) {
      // request here.com autocomplete address
      apiGetAutocompleteList(address, cusLat, cusLng, (locationsList) => {
        devLog("customer lat long", cusLat, ", ", cusLng);
        if (typeof locationsList !== "object" || !Array.isArray(locationsList.results)) {
          this.setState({
            autocompleteList: [],
            searchLoading: false,
          });
          return;
        }
        devLog("LocationsList", locationsList.results);
        const newLocationsList = locationsList.results.filter((result) => {
          // Validate that the result is a valid two-to address
          if (!validateAddressResult(result)) {
            return false;
          }
          // getDistanceMatrix(cusLat, cusLng, result.geometry.location.lat, result.geometry.location.lng, (distance) => {
          //   devLog("distance: ", distance);
          // });
          let BIsValidCountry = false;
          for (let i = 0; i < result.address_components.length; i++) {
            const comp = result.address_components[i];
            if (
              Array.isArray(comp.types) &&
              comp.types.findIndex((type) => {
                return type === "country";
              }) >= 0 &&
              countrySearchWhitelist.indexOf(comp.short_name) >= 0
            ) {
              BIsValidCountry = true;
              break;
            }
          }
          return BIsValidCountry;
        });

        devLog("newLocationsList", newLocationsList);

        // no more than 3 results will be displayed
        this.setState(
          {
            autocompleteList: newLocationsList.length < 4 ? newLocationsList : newLocationsList.slice(0, 3),
            isPepBoysStore: false,
            searchLoading: false,
            // autoCompleteList: newLocationsList,
          },
          () => {
            devLog("getAutoCompleteList this.state after setState: ", this.state);
          },
        );
      });
    } else {
      // Clear loading if address is too short
      this.setState({
        searchLoading: false,
      });
    }
  };

  distanceConvert = (distance, unit, country) => {
    if (distance === null || distance === undefined || isNaN(distance)) {
      return "0.00";
    }
    if (this.state?.partner === "ARIC" || this.state?.partner === "ARIU") {
      devLog("distanceConvert holman: ", distance);
      return distance;
    }

    let convertedDistance;

    if (unit) {
      if (unit === "mi") {
        convertedDistance = (distance * 0.000621371).toFixed(2);
      } else if (unit === "km") {
        convertedDistance = (distance * 0.001).toFixed(2);
      } else {
        convertedDistance = typeof distance === "number" ? distance.toFixed(2) : distance;
      }
      return convertedDistance;
    } else if (country) {
      if (country === "CAN" || country === "Canada") {
        convertedDistance = (distance * 1.60934).toFixed(2);
      } else {
        convertedDistance = typeof distance === "number" ? distance.toFixed(2) : distance;
      }
      return convertedDistance;
    }
  };

  render() {
    return (
      <>
        <Fade
          in={this.state.destinationSelectLoading}
          timeout={{ enter: 280, exit: 220 }}
          mountOnEnter
          unmountOnExit
          easing={{ enter: "cubic-bezier(0, 0, 0.2, 1)", exit: "cubic-bezier(0.4, 0, 1, 1)" }}
        >
          <div className="select-destination-loading-root" role="status" aria-live="polite" aria-busy="true">
            <div className="select-destination-loading-backdrop" aria-hidden="true" />
            <div className="select-destination-loading-panel">
              <div className="select-destination-loading-spinner">
                <svg
                  aria-hidden="true"
                  className="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
                  viewBox="0 0 100 101"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                    fill="currentColor"
                  />
                  <path
                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                    fill="currentFill"
                  />
                </svg>
                <span className="sr-only">{this.state.t("description.LoadingModalAlt")}</span>
              </div>
              <span className="select-destination-loading-caption">Confirming Destination...</span>
            </div>
          </div>
        </Fade>
        <div className="bg-gray-200 w-full pb-10">
          {/* Header */}
          <div className="bg-black h-24 w-full flex justify-equal items-center">
            {/* Back button */}
            <div
              className="text-white flex items-center"
              onClick={(e) => {
                if (typeof this.props.onUserBack === "function") {
                  this.props.onUserBack();
                }
              }}
            >
              <ChevronLeft className="text-white" style={{ width: "40px", height: "40px" }} />
            </div>
            <div className="flex justify-center items-center">
              <div>
                <img
                  className={this.props.currState.partner === "PBFL" ? "w-20" : "w-12"}
                  src={this.props.currState.partner === "PBFL" ? this.props.logo : WhiteWrenchIcon}
                  alt="trx now logo"
                />
              </div>
              <div className="flex flex-col ml-4">
                <div className="sm:text-lg font-semibold text-white" style={{ marginRight: "10px" }}>
                  {this.state.t("description.ConfirmDestinationTitleBar1")}
                </div>{" "}
                {/*}  */}
                <div className="text-xs text-white">{this.state.t("description.ConfirmDestinationTitleBar2")}</div>{" "}
                {/*  */}
              </div>
            </div>
          </div>

          {/* Optional Map */}
          {/* <TrxNowGoogleMap 														
						zoom={14}
						width={'100%'}
						height={300}
						markers={[
                            { position: { lat: 36.317126, lng: -82.351134 }, icon: DestMapMarker },
                            { position: { lat: 36.329926, lng: -82.351934 }, icon: DestMapMarker },								
                        ]}
                    /> */}

          {/* search bar */}
          {this.state.showSearch && this.state.partner !== "PEP" && (
            <div className="m-4">
              <div className="relative rounded-md shadow-sm">
                <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                  <MagnifyingGlassIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                </div>
                <input
                  type="search"
                  name="search"
                  id="search"
                  className="w-full bg-white h-12 rounded-md border-gray-300 pl-10 sm:text-sm"
                  placeholder={this.state.t("description.ConfirmDestinationAutoComplete1")}
                  onChange={(e) =>
                    this.state.partner === "PBFL"
                      ? this.handlePepBoysSearch(e.target.value)
                      : this.handleSearch(e.target.value)
                  }
                />
              </div>
              {this.state.incompleteAddressMsg && (
                <Alert severity="error">{this.state.t("description.IncompleteDestAddressMsg")}</Alert>
              )}

              {/* Spinner for autocomplete search only (destination confirm uses fullscreen overlay) */}
              {(this.state.pepBoysSearchLoading || this.state.searchLoading) && (
                <div className="flex flex-col items-center justify-center mt-4">
                  <Spinner
                    animation="border"
                    variant="primary"
                    style={{
                      marginBottom: "10px",
                      width: "3rem",
                      height: "3rem",
                    }}
                  />
                  <div className="flex flex-row items-center">
                    <span className="mr-2">Searching...</span>
                    <PulseLoader color="#000000" margin={3} size={6} />
                  </div>
                </div>
              )}

              {/* Autocomplete fields */}
              {this.state.autocompleteList && this.state.autocompleteList.length > 0 ? (
                this.state.autocompleteList.map((location, index) => (
                  <div
                    key={`li-autocomplete-${index}`}
                    className="cursor-pointer mt-3"
                    onClick={(e) => {
                      this.state.partner === "PBFL" && !this.state.isPepBoysStore
                        ? //? this.openPEPMsgModal(location.formatted_address)
                          this.checkPepBoysStore(location.formatted_address)
                        : this.handleAddressSelection(location.formatted_address);
                    }}
                  >
                    <Divider />
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                        minHeight: 60,
                        background: "white",
                        padding: 10,
                      }}
                    >
                      <div
                        style={{
                          marginRight: 20,
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "flex-start",
                        }}
                      >
                        <p
                          style={{
                            marginTop: "auto",
                            marginBottom: "auto",
                            color: "black",
                            fontWeight: 500,
                          }}
                        >
                          <span className="font-semibold text-sm text-blue-600">
                            {this.state.partner === "PBFL" && this.state.isPepBoysStore
                              ? location.name
                              : "Select This Address as the Destination:"}
                          </span>
                          <br />
                          {location.formatted_address}
                        </p>
                      </div>
                      <button
                        id="selectButton"
                        className="bg-black px-2 py-2 rounded-md text-center text-white font-bold text-sm"
                        // onClick={(e) => {
                        //   this.handleAddressSelection(location.formatted_address);
                        // }}
                      >
                        Select
                      </button>
                    </div>
                  </div>
                ))
              ) : (
                <div className="flex flex-row mt-3 p-2 justify-center w-full bg-white">
                  {" "}
                  {/* style={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', width: '100%', minHeight: 60, background: 'white', padding: 10}} */}
                  <div
                    style={{
                      marginRight: 20,
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "flex-start",
                    }}
                  >
                    <p
                      style={{
                        marginTop: "auto",
                        marginBottom: "auto",
                        color: "black",
                        fontWeight: 500,
                      }}
                    >
                      {this.state.t("description.ConfirmDestinationInstructions")}
                    </p>
                  </div>
                </div>
              )}
            </div>
          )}

          {/* Search Locations / Preferred Locations */}
          {/* <div className="w-full flex justify-center items-center my-4">
              <span className="isolate inline-flex rounded-md shadow-sm">
                  <button
                      type="button"
                      className="relative inline-flex items-center rounded-l-md border border-gray-300 bg-blue-500 px-4 py-2 text-sm text-white font-semibold"
                  >
                      Search Locations
                  </button>
                  <button
                      type="button"
                      className="relative -ml-px inline-flex items-center border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-10 focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500"
                  >
                      Preferred Locations
                  </button>                            
              </span>
          </div> */}

          {this.state.showSpinner && this.state.partner !== "PEP" && (
            <>
              <div className="bg-black h-10 pl-4 font-bold text-white flex items-center">Nearby Service Centers</div>
              <div className="flex flex-col items-center font-bold mt-5">
                <Spinner
                  animation="border"
                  variant="primary"
                  style={{
                    marginBottom: "20px",
                    width: "5rem",
                    height: "5rem",
                  }}
                />
                <div className="flex flex-row items-center mt-3 mb-3">
                  <span className="mr-2">Loading</span>
                  <span>
                    <PulseLoader color="#000000" margin={3} size={8} />
                  </span>
                </div>
              </div>
            </>
          )}

          {this.state.showSpinner && this.state.partner === "PEP" && (
            <>
              <div className="flex flex-col items-center font-bold mt-5">
                <Spinner
                  animation="border"
                  variant="primary"
                  style={{
                    marginBottom: "20px",
                    width: "5rem",
                    height: "5rem",
                  }}
                />
                <div className="flex flex-row items-center mt-3 mb-3">
                  <span className="mr-2">Loading</span>
                  <span>
                    <PulseLoader color="#000000" margin={3} size={8} />
                  </span>
                </div>
              </div>
            </>
          )}

          {/* Promoted Services Centers */}
          {this.state && !this.state.showSpinner && this.state.preferredList && this.state.preferredList.length ? (
            <div
              className="bg-black h-10 pl-4 font-bold text-white flex items-center"
              style={{
                borderTop: this.state.partner === "PBFL" ? "1px solid rgba(225,225,225,.5)" : "none",
              }}
            >
              {this.state.partner === "PBFL"
                ? this.state.t("SelectDestination.ListTitleNearbyServiceCenters")
                : this.state.t("SelectDestination.ListTitlePromotedServiceCenters")}
            </div>
          ) : (
            <></>
          )}

          {/* Prefer Locations Found */}
          {this.state?.preferredList &&
            this.state.preferredList.map((item, index) => (
              <div
                key={index}
                className={`w-full bg-white border-b-2 border-b-gray-300 px-4 py-3 ${
                  item.preferred ? "preferred" : "non-preferred"
                }`}
              >
                <div className="flex justify-between items-center">
                  <div className="flex flex-col">
                    <div className="font-semibold">{item.name}</div>
                    <div className="text-xs text-gray-400">{item.vicinity}</div>
                    <div className="font-semibold">
                      Distance: {parseFloat(item.distance).toFixed(2)}
                      {item.distanceUnit}
                      {/* {item.distanceUnit === "mi" ? item.distance : (item.distance * 1.609344).toFixed(2)}
                      {item.distanceUnit === "mi" ? "mi" : "km"} */}
                    </div>
                  </div>
                  {/* <div className="bg-black px-2 py-2 rounded-md text-center text-white font-bold text-sm">
                    Select
                  </div> */}
                  <Button
                    style={{ fontWeight: "bold" }}
                    variant="primary"
                    size="sm"
                    onClick={(e) => this.handleSelection(item.geometry.location, item)}
                  >
                    {this.state.partner === "PBFL"
                      ? `$${calTowPriceWithDist(
                          this.state.subPartnerName === "Sears Transformco"
                            ? Math.ceil(item.distance)
                            : parseFloat(item.distance).toFixed(2),
                          this.state.fixedDistanceLimit,
                          this.state.fixedPrice,
                          this.state.fixedDistanceFee,
                        )}`
                      : "Select"}
                  </Button>
                </div>
              </div>
            ))}

          {/* List of Near By Places */}
          {!this.state.showSpinner &&
            this.state.destList &&
            this.state.partner !== "PEP" &&
            this.state.partner !== "PBFL" && (
              <div className="bg-black h-10 pl-4 font-bold text-white flex items-center">
                {t("SelectDestination.ListTitleNearbyServiceCenters")}
              </div>
            )}

          {/* No Locations Found */}
          {!this.state && !this.state.showSpinner && !this.state.destList && this.state.destList.length < 1 ? (
            <div className="w-full bg-white border-b-2 border-b-gray-300 px-4 py-8">
              <div className="flex flex-col items-center ">
                <MagnifyingGlassCircleIcon className="w-8 text-gray-400" />
                <div className="text-center font-bold text-gray-400">No Locations Found</div>
                <div className="text-center text-sm text-gray-400">
                  Please enter a location or check the submitted location and try again. You may also search by name or
                  type.
                </div>
              </div>
            </div>
          ) : (
            <></>
          )}

          {/* Nearby Service Centers List */}
          {this.state?.destList &&
            this.state.partner !== "PEP" &&
            this.state.destList.map((item, index) => (
              <div
                key={index}
                className={`w-full bg-white border-b-2 border-b-gray-300 px-4 py-3 ${
                  item.preferred ? "preferred" : "non-preferred"
                }`}
              >
                <div className="flex justify-between items-center">
                  <div className="flex flex-col">
                    <div className="font-semibold">{item.name}</div>

                    <div className="text-xs text-gray-400">{item.vicinity}</div>

                    <div className="font-semibold">
                      Distance: {item.distance}
                      {item.distanceUnit}
                    </div>
                  </div>

                  {this.state.showSelectBtn && (
                    <Button
                      style={{ fontWeight: "bold" }}
                      className="bg-black px-2 py-2 rounded-md text-center text-white font-bold text-sm"
                      variant="dark"
                      size="sm "
                      onClick={(e) => this.handleSelection(item.geometry.location, item)}
                    >
                      {this.state.partner === "PBFL" ? "$90" : "Select"}
                    </Button>
                  )}
                </div>
              </div>
            ))}
          {!this.state.isPepBoysStore && this.state.partner === "PBFL" && this.state.isPepBoysStoreMsgModalOpen && (
            <Modal
              classNames={{ modal: "PPUConsentScreen" }}
              open={this.state.isPepBoysStoreMsgModalOpen}
              onClose={this.closePEPMsgModal}
              closeOnOverlayClick={false}
              closeOnEsc={false}
              showCloseIcon={false}
              style={{ margin: "0 auto", width: "auto" }}
            >
              <h2 style={{ marginTop: 30 }}>{t("description.TVLAccidentQuestionHeader")}</h2>
              <div className="message">
                Since you are not towing to a Pep Boys location, you will need to pay us with a Debit or Credit Card.
              </div>
              <div className="footerContainer">
                <div
                  type="hidden"
                  onClick={this.closePEPMsgModal}
                  className="footer"
                  style={{ backgroundColor: "#cccccc", color: "black" }}
                >
                  <span>Search Again</span>
                </div>
                <div
                  type="hidden"
                  onClick={() => this.handleAddressSelection(this.state.pepBoysStoreAddress)}
                  className="footer"
                >
                  <span>Continue</span>
                </div>
              </div>
            </Modal>
          )}
        </div>
      </>
    );
  }
}

/* <React.Fragment>
    <div style={{
        background: 'black',
        color: 'white',
        width: '100%',
        textAlign: 'left',                    
    }}>
        <button 
            type="button" 
            style={{background: 'black', color: 'white', border: 'none', display: 'flex', flexDirection: 'row', alignItems: 'center'}}
            onClick={()=> {
                if (this.props.backButtonFunc) {
                    this.props.backButtonFunc();
                }
            }}
            >

            <ChevronLeft style={{color: 'white', height: 32}} /> <div>Back</div>
        </button>
    </div>
    {(this.state.destList && this.state.destList !== [] ) && <NewWebAppMapClass zoomLevel={11} height={"300px"} destList={this.state.destList} mapCreated={this.mapCreated} disablementCoords={this.state.disablementCoords} callBackFunc={this.tempPrint}/>}
    <TitleBar data={LocateUserObj}/>
    <DestinationList submitFunc={this.tempPrint}/>
    {( this.state.destList ) && <NEWDestinationList submitFunc={this.tempPrint} disablementCoords={this.state.disablementCoords} destList={this.state.destList}/>} 
</React.Fragment> */
